import { render, staticRenderFns } from "./AffiliateAccounts.vue?vue&type=template&id=4cd6b032&"
import script from "./AffiliateAccounts.vue?vue&type=script&lang=js&"
export * from "./AffiliateAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports